import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { MoveLeft } from "lucide-react";
import {  useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { toast } from "react-hot-toast";

// import { verifyOtp } from "../../redux/slices/authSlice";

import "../Loginsignup/login-signup.css";

import './style.css';

export default function OtpVerification() {
  // const dispatch = useDispatch();
  const navigate = useNavigate(); // Define navigate
  const { loading, error } = useSelector((state) => state.auth); // Define loading and error
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const [otpData, setOtpData] = useState({
    otp: "",
  });

  useEffect(() => {
    // body bg color
    document.body.style.backgroundColor = "#f0f0f0";
    return () => {
      document.body.style.backgroundColor = "#fff";
    };
  }, []);

  const handleChange = (e) => {
    setOtpData({
      ...otpData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (otpData.otp === "") {
      toast.error("OTP is required");
      return;
    }

    // dispatch(verifyOtp(otpData.otp));
    toast.success("OTP verified successfully");
    navigate("/reset-password");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Left Panel - Candy World */}
        {isDesktop && (
          <div className="login-panel candy-panel">
            {isDesktop && (
              <div className="back-button">
                <button>
                  <MoveLeft size={24} color="#fff" />
                </button>
              </div>
            )}
            <div className="candy-content">
              <h2 className="candy-title">Your Candy World</h2>
              <h3 className="candy-subtitle">Awaits</h3>
              <div className="curved-line"></div>
              <p className="candy-description">
                Manage your orders, track shipments, and discover exclusive deals. Enjoy new arrivals, special discounts,
                and a world of delightful treats just for you!
              </p>
            </div>
            <div className="candy-image">
              <img
                src="/1.png"
                alt="Candy character"
              />
            </div>
          </div>
        )}

        {/* Right Panel - OTP Verification Form */}
        <div className="login-panel form-panel">
          <div className="brand-logo">
            <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1742812127/derby-logo_1_goi8kp.png" alt="Derby logo" className="logo-image" />
          </div>
          <div className="form-header">
            <h2>Verify OTP</h2>
            <p className="form-subtitle">
              Enter the OTP sent to your email address
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="otp"
                placeholder="Enter OTP"
                value={otpData.otp}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Processing..." : "Verify OTP"}
            </button>
          </form>

          <div className="auth-switch">
            <p>
              Didn't receive an OTP? <Link to="/forgot-password">Resend</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
